module.exports = __webpack_public_path__ + "static/media/manageLeavesIcon.8f483cd3.svg";